import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryListBulletsIntegrityProps {
    items?: CuratedItem[] | [];
}

export default function integrityCheck({
    items,
}: StoryListBulletsIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items);
}
